import styles from "./Ratings.module.scss";
import vectorIcon from "./icons/vector.png";
import { ContentWrapper } from "../../components/ContentWrapper/ContentWrapper";
import { PageTitleBlock } from "../../components/PageTitleBlock/PageTitleBlock";
import { CardWrapper } from "../../components/CardWrapper/CardWrapper";
import { RatingCard } from "../../components/RatingCard/RatingCard";
import { useDispatch, useSelector } from "../../hooks";
import { useEffect } from "react";
import { getRatings } from "../../redux/ratings/get-ratings.handler";
import { Loader } from "../../components/Loader/Loader";
import { ErrorSnackbar } from "../../components/ErrorSnackbar/ErrorSnackbar";
import { RatingsPanel } from "./RatingsPanel/RatingsPanel";
import { getAssets } from "../../redux/assets/get-assets.handler";

export const RatingsPage = () => {
    const { users: usersRating, current, loading, error } = useSelector(store => store.rating);
    const ratings = useSelector(store => store.assets.ratings);

    const dispatch = useDispatch();

     useEffect(() => {
        if (ratings.length)
            return;

        dispatch(getAssets());
    }, [dispatch, ratings]);

    useEffect(() => {
        if (!current)
            return;

        dispatch(getRatings(current));
    }, [dispatch, current]);

    const getDescription = () => ratings.find(item => item.type === current)?.name;

    return (
        <>
            <ContentWrapper>
                <div className={styles.wrapper}>
                    <PageTitleBlock
                        pageTitle={"Рейтинг"}
                        pageDescription={getDescription()}
                    />

                    <RatingsPanel />

                    <CardWrapper>
                        {usersRating && usersRating.map((data, index) => (
                            <>
                                { (usersRating.length - 1 === index && index > 49) && <img alt="split" src={vectorIcon} /> }

                                <RatingCard
                                    key={`rating-card${index}`}
                                    rank={data.rank}
                                    avatar={data.avatar}
                                    name={data.username}
                                    score={data.value}
                                    my={data.my}
                                />
                            </>
                        ))}
                    </CardWrapper>
                </div>
            </ContentWrapper>

            { loading && <Loader /> }
            { error.length > 0 && <ErrorSnackbar errorMessage={ error } /> }
        </>
    );
};